
import React, { useState, useEffect } from "react";
import { MenuItem, Select, FormControl, Box } from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import QRCode from "qrcode.react";
import EmailIcon from "@mui/icons-material/Email";
import PublicIcon from "@mui/icons-material/Public";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BusinessIcon from "@mui/icons-material/Business";
import InfoIcon from "@mui/icons-material/Info";
import DefaultProfileBg from "../../Assets/img/card/profilebg.png";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
// import profile from "../../Assets/img/icons/User-Profile-Pic.svg";
import Gmail from "../../Assets/img/icons/Gmail.svg";
import Outlook from "../../Assets/img/icons/outlook.svg";
import Apple from "../../Assets/img/icons/apple.svg";
import Email from "../../Assets/img/icons/email.svg";
// import card1 from "../../Assets/img/Card1.png";
// import card2 from "../../Assets/img/Card2.png";
// import QrcodeScan from "../../Assets/img/icons/QRcode Scanner.svg";
// import NeoinScan from "../../Assets/img/icons/Neoin-at-center.svg";
// import companylogo from "../../Assets/img/Neoin-logo.png";
import NeoinQR from "../../Assets/img/icons/QR-with-Neoin.svg";
// import DefaultProfile from "../../Assets/img/Default-Profile.png";
import Switch from "@mui/material/Switch";
// import axios from "axios";
// import { ReactComponent as CardWaveWithoutShadow } from "../../Assets/img/card/waveline new.svg";
import { Stepper, Step, StepLabel, Button } from "@mui/material";
import { useUserDetailContext } from "../UserDetailContext";
import CardWaveSmile from "../Utilities/CardWaveSmile2";
import CardWaveStd from "../Utilities/CardWaveStd";
import { useLocation } from "react-router-dom";
import { useQuantityContext } from "../QuantityContext";

const Lightbox = ({ isOpen, handleClose, emailSignature }) => {
  const [activeMenu, setActiveMenu] = useState("inbox");

  const handleMenuClick = (menu) => {
    setActiveMenu(menu);
  };
  const { handleInfo } = useQuantityContext();

  const handleCopySignature = () => {
    // Copy the email signature to the clipboard
    navigator.clipboard
      .write([
        new ClipboardItem({
          "text/html": new Blob([emailSignature], { type: "text/html" }),
        }),
      ])
      .then(() => {
        // alert("Signature copied to clipboard!");
        handleInfo("Signature copied to clipboard!");
      })
      .catch((error) => {
        console.error("Failed to copy signature: ", error);
      });
  };

  return (
    <div className={`lightbox ${isOpen ? "open" : ""}`}>
      <div className="content">
        <h2>How to add a signature to your emails</h2>
        <span className="sub-tit-email">
          Select your email provider below and follow to the steps to add your
          signature
        </span>
        <button type="button" className="lightbox__close" onClick={handleClose}>
          &times;
        </button>

        <div className="mt-20 menu">
          <div
            onClick={() => handleMenuClick("inbox")}
            className={`menu-item ${activeMenu === "inbox" ? "active" : ""}`}
          >
            <div className="container-gift">
              <img src={Gmail} alt="Gmail" />
              <span>Gmail</span>
            </div>
          </div>
          <div
            onClick={() => handleMenuClick("web_outbox")}
            className={`menu-item ${activeMenu === "web_outbox" ? "active" : ""
              }`}
          >
            <div className="container-gift">
              <img src={Outlook} alt="Outlook" />
              <span>Outlook Web</span>
            </div>
          </div>
          <div
            onClick={() => handleMenuClick("desktop_outbox")}
            className={`menu-item ${activeMenu === "desktop_outbox" ? "active" : ""
              }`}
          >
            <div className="container-gift">
              <img src={Outlook} alt="Outlook" />
              <span>Outlook Desktop</span>
            </div>
          </div>
          <div
            onClick={() => handleMenuClick("web_apple")}
            className={`menu-item ${activeMenu === "web_apple" ? "active" : ""
              }`}
          >
            <div className="container-gift">
              <img src={Apple} alt="Apple" />
              <span>Mail</span>
            </div>
          </div>

          <div
            onClick={() => handleMenuClick("desktop_apple")}
            className={`menu-item ${activeMenu === "desktop_apple" ? "active" : ""
              }`}
          >
            <div className="container-gift">
              <img src={Apple} alt="Apple" />
              <span>iPhone/ iPad</span>
            </div>
          </div>

          <div
            onClick={() => handleMenuClick("others")}
            className={`menu-item ${activeMenu === "others" ? "active" : ""}`}
          >
            <div className="container-gift">
              <img src={Email} alt="Email" />
              <span>Others</span>
            </div>
          </div>
        </div>

        <div className="rsuite-container">
          <div className="ml-20px content-for-Email">
            {activeMenu === "inbox" && (
              <div className="menu-content">
                <Stepper className="mail-sign-stepper" orientation="vertical">
                  <Step>
                    <StepLabel className="custom-step-icon">
                      <br />
                    </StepLabel>
                  </Step>
                  <Step>
                    <StepLabel className="custom-step-icon">STEP 1</StepLabel>
                    <div className="description-content-1">
                      Generate and copy your signature's HTML
                      <button
                        className="ml-20px Add-to-Email"
                        onClick={handleCopySignature}
                      >
                        Copy Signature
                      </button>
                    </div>
                  </Step>
                  <Step>
                    <StepLabel className="custom-step-icon">STEP 2</StepLabel>
                    <div className="description-content-1">
                      Within your Gmail account, click the gear icon on the top
                      right, select the “See all settings” option and scroll
                      down to the “Signature” section.
                    </div>
                  </Step>
                  <Step>
                    <StepLabel className="custom-step-icon">STEP 3</StepLabel>
                    <div className="description-content-1">
                      Select the “Create new” option and paste your email
                      signature into the text box
                    </div>
                  </Step>
                  <Step>
                    <StepLabel className="custom-step-icon">STEP 4</StepLabel>
                    <div className="description-content-1">
                      In the “Signature Defaults” subsection, select your newly
                      created signature as default and then scroll down to the
                      very bottom of the page and select the “Save” button
                    </div>
                  </Step>
                </Stepper>
              </div>
            )}
            {activeMenu === "web_outbox" && (
              <div className="menu-content">
                <Stepper className="mail-sign-stepper" orientation="vertical">
                  <Step>
                    <StepLabel className="custom-step-icon">
                      <br />
                    </StepLabel>
                  </Step>
                  <Step>
                    <StepLabel className="custom-step-icon">STEP 1</StepLabel>
                    <div className="description-content-1">
                      Generate and copy your signature's HTML
                      <button
                        className="ml-20px Add-to-Email"
                        onClick={handleCopySignature}
                      >
                        Copy Signature
                      </button>
                    </div>
                  </Step>
                  <Step>
                    <StepLabel className="custom-step-icon">STEP 2</StepLabel>
                    <div className="description-content-1">
                      Within your Outlook account, select the gear icon in the
                      top right followed by the “Compose and reply” option just
                      below the “Layout” tab at the top.
                    </div>
                  </Step>
                  <Step>
                    <StepLabel className="custom-step-icon">STEP 3</StepLabel>
                    <div className="description-content-1">
                      Click on “New signature”, provide a name for your
                      signature and then paste your email signature into the
                      larger text box
                    </div>
                  </Step>
                  <Step>
                    <StepLabel className="custom-step-icon">STEP 4</StepLabel>
                    <div className="description-content-1">
                      In the “Select default signatures” subsection below,
                      choose your newly created signature as default and click
                      the blue save button in the bottom right Copy Signature
                    </div>
                  </Step>
                </Stepper>
              </div>
            )}
            {activeMenu === "desktop_outbox" && (
              <div className="menu-content">
                <Stepper className="mail-sign-stepper" orientation="vertical">
                  <Step>
                    <StepLabel>
                      <br />
                    </StepLabel>
                  </Step>
                  <Step>
                    <StepLabel>STEP 1</StepLabel>
                    <div className="description-content-1">
                      Generate and copy your signature's HTML
                      <button
                        className="ml-20px Add-to-Email"
                        onClick={handleCopySignature}
                      >
                        Copy Signature
                      </button>
                    </div>
                  </Step>
                  <Step>
                    <StepLabel>STEP 2</StepLabel>
                    <div className="description-content-1">
                      (Windows) Within Outlook, select the “File” in the top
                      left corner, followed by “Options” then “Mail” (Mac)
                      Select “Outlook” in the top left corner, then
                      “Preferences”.
                    </div>
                  </Step>
                  <Step>
                    <StepLabel>STEP 3</StepLabel>
                    <div className="description-content-1">
                      Click on “Signatures” in the menu/popup.
                    </div>
                  </Step>
                  <Step>
                    <StepLabel>STEP 4</StepLabel>
                    <div className="description-content-1">
                      Set your newly created signature as default Copy
                      Signature.
                    </div>
                  </Step>
                </Stepper>
              </div>
            )}
            {activeMenu === "web_apple" && (
              <div className="menu-content">
                <Stepper className="mail-sign-stepper" orientation="vertical">
                  <Step>
                    <StepLabel>
                      <br />
                    </StepLabel>
                  </Step>
                  <Step>
                    <StepLabel>STEP 1</StepLabel>
                    <div className="description-content-1">
                      Generate and copy your signature's HTML
                      <button
                        className="ml-20px Add-to-Email"
                        onClick={handleCopySignature}
                      >
                        Copy Signature
                      </button>
                    </div>
                  </Step>
                  <Step>
                    <StepLabel>STEP 2</StepLabel>
                    <div className="description-content-1">
                      Within the mail app, select “Mail” in the top left corner,
                      followed by “Preferences” and then click on the
                      “Signatures” tab.
                    </div>
                  </Step>
                  <Step>
                    <StepLabel>STEP 3</StepLabel>
                    <div className="description-content-1">
                      Paste your email signature into the text box on the right
                      side and make sure the “Always match my default message
                      font” setting is unselected. If you don’t have any
                      existing signatures you will have to first create one by
                      clicking on the “+” sign at the bottom.
                    </div>
                  </Step>
                  <Step>
                    <StepLabel>STEP 4</StepLabel>
                    <div className="description-content-1">
                      Open the “Choose Signature” popup and then select your
                      newly created signature.
                    </div>
                  </Step>
                </Stepper>

                <div className="warning-apple">
                  <div className="digital-card-line">
                    <InfoIcon />
                    <div className="warning">
                      {" "}
                      Your email signature won't be fully visible in the preview
                      after your paste it in. It will still come through
                      correctly however, when sending emails
                    </div>
                  </div>
                </div>
              </div>
            )}
            {activeMenu === "desktop_apple" && (
              <div className="menu-content">
                <Stepper className="mail-sign-stepper" orientation="vertical">
                  <Step>
                    <StepLabel>
                      <br />
                    </StepLabel>
                  </Step>
                  <Step>
                    <StepLabel>STEP 1</StepLabel>
                    <div className="description-content-1">
                      Generate and copy your signature's HTML
                      <button
                        className="ml-20px Add-to-Email"
                        onClick={handleCopySignature}
                      >
                        Copy Signature
                      </button>
                    </div>
                  </Step>
                  <Step>
                    <StepLabel>STEP 2</StepLabel>
                    <div className="description-content-1">
                      Open the "Settings" app.
                    </div>
                  </Step>
                  <Step>
                    <StepLabel>STEP 3</StepLabel>
                    <div className="description-content-1">
                      Scroll down and choose "Mail".
                    </div>
                  </Step>
                  <Step>
                    <StepLabel>STEP 4</StepLabel>
                    <div className="description-content-1">
                      Scroll down and tap "Signature".
                    </div>
                  </Step>
                  <Step>
                    <StepLabel>STEP 5</StepLabel>
                    <div className="description-content-1">
                      Paste the Neoin signature into the appropriate account.
                    </div>
                  </Step>
                </Stepper>
                <div className="warning-apple">
                  <div className="digital-card-line">
                    <InfoIcon />
                    <div className="warning">
                      {" "}
                      Your email signature won't be fully visible in the preview
                      after your paste it in. It will still come through
                      correctly however, when sending emails
                    </div>
                  </div>
                </div>
              </div>
            )}
            {activeMenu === "others" && (
              <div className="menu-content">
                <Stepper className="mail-sign-stepper" orientation="vertical">
                  <Step>
                    <StepLabel></StepLabel>
                  </Step>
                  <Step>
                    <StepLabel>STEP 1</StepLabel>
                    <div className="description-content-1">
                      Generate and copy your signature's HTML
                      <button
                        className="ml-20px Add-to-Email"
                        onClick={handleCopySignature}
                      >
                        Copy Signature
                      </button>
                    </div>
                  </Step>
                  <Step>
                    <StepLabel>STEP 2</StepLabel>
                    <div className="description-content-1">
                      You can add an email signature directly within an email or
                      in Settings for most email platforms.
                    </div>
                  </Step>
                </Stepper>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const DigitalIdentityPaid = () => {
  const { userDetails, cards, cardDetailsAll, cardStylesAll } =
    useUserDetailContext();

  const location = useLocation();
  const { someProp } = location.state || "personal";
  // const [emailSignature, setEmailSignature] = useState(""); // State variable to hold email signature
  const [selectedCard, setSelectedCard] = useState(someProp || "Personal");

  const apiKey = process.env.REACT_APP_API_KEY;
  const objectId = localStorage.getItem("objectId");
  const headers = {
    "x-api-key": apiKey,
    "Content-Type": "application/json",
    Authorization: `Bearer ${objectId}`,
  };

  // const [CardProfilePic, setCardProfilePic] = useState();
  // const [selectedcardLogo, setSelectedcardLogo] = useState();
  // const [CardProfession, setCardProfession] = useState();

  const [cardDetailsForProfile, setCardDetailsForProfile] = useState({
    User_ID: objectId,
    profile_pic: "",
    logo: "",
    designation: "Profession",
  });

  const [cardDetailsForPersonal, setCardDetailsForPersonal] = useState({
    User_ID: objectId,
    profile_pic: "",
    logo: "",
    title: "Title",
  });

  const [cardDetailsForStudent, setCardDetailsForStudent] = useState({
    User_ID: objectId,
    profile_pic: "",
    logo: "",
    designation: "",
    title: "Title",
  });

  const [cardDetailsForGenZ, setCardDetailsForGenZ] = useState({
    User_ID: objectId,
    profile_pic: "",
    logo: "",
    designation: "Profession",
    title: "Title",
  });

  const cardStylesProperties = {
    font: "",
    style: "",
    colorPrimary: "",
    colorSecondary: "",
    colorTitle: "",
    colorLayout: "#0044C6",
    bgColor: "#ffffff",
  };

  const [CardProfession, setCardProfession] = useState(
    cardDetailsForPersonal?.title || DefaultProfileBg
  );
  const [CardProfilePic, setCardProfilePic] = useState(
    cardDetailsForPersonal?.profile_pic || DefaultProfileBg
  );
  const [cardLogo, setSelectedcardLogo] = useState(
    cardDetailsForPersonal?.logo || DefaultProfileBg
  );
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const toggleLightbox = () => {
    setLightboxOpen(!lightboxOpen);
  };

  const handleCloseLightbox = () => {
    setLightboxOpen(false);
  };

  const handleClick = () => {
    toggleLightbox();
  };

  const convertToBase64 = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const handleCardClick = async (userCardName) => {
    setSelectedCard(userCardName);
    const data = cardDetailsAll[userCardName];
    const profilePicture = data?.profile_pic || DefaultProfileBg;
    const logo = data?.logo || DefaultProfileBg;

    const profilePicBase64 = await convertToBase64(profilePicture);
    setCardProfilePic(profilePicBase64);

    const logoBase64 = await convertToBase64(logo);
    setSelectedcardLogo(logoBase64);

    const Profession =
      data?.CardType !== "Professional" ||
        userCardName !== "Customize_Professional"
        ? data?.title
        : data?.designation;
    setCardProfession(Profession || "");
  };

  const label = { inputProps: { "aria-label": "Size switch demo" } };

  // State to manage active link
  const [activeLink, setActiveLink] = useState("content1");

  // State variables for customizations
  const [fontColor, setFontColor] = useState("#0044C6"); // Default font color
  const [borderColor, setBorderColor] = useState("#ccc"); // Default border color
  const [fontStyle, setFontStyle] = useState("Lato"); // Default font style

  // Function to handle click on links
  const handleLinkClick = (content) => {
    setActiveLink(content);
  };

  // Predefined color options
  const predefinedFontColors = ["#000", "#B0B0B0", "#FF9800", "#828593"];
  const predefinedBorderColors = ["#757575", "#0044C6", "#FF82AC", "#00DBE4"];

  const fontStyleOptions = [
    { label: "Default", value: "Lato" },
    { label: "Poppins", value: "Poppins, sans-serif" },
    { label: "Roboto", value: "Roboto, sans-serif" },
  ];

  // Function to handle selection of font color
  const handleFontColorChange = (color) => {
    setFontColor(color);
  };

  // Function to handle selection of border color
  const handleBorderColorChange = (color) => {
    setBorderColor(color);
  };

  /* For Displaying the Card*/
  const [defaultChecked, setDefaultChecked] = useState(true);
  const [qrChecked, setQRChecked] = useState(false);
  const [textChecked, setTextChecked] = useState(false);
  const [profileChecked, setProfileChecked] = useState(false);
  const [logoChecked, setLogoChecked] = useState(false);
  const [borderlineChecked, setBorderlineChecked] = useState(false);
  // const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    if (
      !qrChecked &&
      !textChecked &&
      !profileChecked &&
      !logoChecked &&
      !borderlineChecked
    ) {
      setDefaultChecked(true);
    }

    if (qrChecked && !textChecked && !profileChecked && !logoChecked) {
    }

    generateEmailSignature();
  }, [
    defaultChecked,
    qrChecked,
    textChecked,
    profileChecked,
    logoChecked,
    borderlineChecked,
  ]);

  // Generate the email signature based on the state variables
  const generateEmailSignature = () => {
    let signature = ""; // Initialize the signature variable

    // Check conditions for different combinations of checkboxes
    if (
      defaultChecked &&
      !qrChecked &&
      !textChecked &&
      !profileChecked &&
      !logoChecked &&
      !borderlineChecked
    ) {
      // Generate the signature for default only
      signature = `
              <!-- Default signature content here -->
              <span style="color: #000000DE; font-size: 16px; font-weight: 400; display: block; padding: 20px;">Preview Card</span>
              <div style="box-shadow: 0px 0px 2px 0px #919EAB33; min-width: 350px; min-height: 160px; border-radius: 8px; margin-bottom: 30px; color: ${fontColor}; border: 1px solid ${borderColor}; font-style: ${fontStyle}; font-family: ${fontStyle};">
                <div style="margin: 10px; width: calc(100% - 20px); height: calc(100% - 20px); box-shadow: 0px 12px 24px 0px #919EAB1F; border-radius: 8px;">
                  <div style="display: flex; flex-direction: column;">
                    <div style="display: flex;">
                      <div style="flex: 2; width: 100%; padding-left: 10px; margin: 20px; color: ${fontColor}; border-radius: 8px; font-style: ${fontStyle}; font-family: ${fontStyle};">
                        <div style="color: ${fontColor}; border-radius: 8px; font-style: ${fontStyle}; font-family: ${fontStyle};">
                          <div style="width: 100%; height: 100%; object-fit: cover;">
                            <img src="${userDetails.proFile}" alt="profile" style="border-radius: 50%; width: 100px;height: 100px; overflow: hidden; border: 5px solid rgba(229, 229, 229, 1);margin-top: 10px;" />
                          </div>
                            <img class="companylogo2" src="${userDetails.companyLogo}" alt="company-alt" style="border-radius: 50%; width: 42px; height: 42px; overflow: hidden; z-index: 999; border: 2px solid rgb(229, 229, 229); margin-left: 39px; margin-top: -83px; position: relative; background: white;" />
                        </div>
                        <p style="font-size: 14px; font-weight: 400; line-height: 16.8px; text-align: left; color: #000000DE;">${userDetails.name}</p>
                        <p style="font-size: 12px; font-weight: 400; text-align: left; color: #00000099; margin-top: 0;">${userDetails.profession}</p>
                      </div>
                      <div style="flex: 2; width: 100%; padding-left: 10px; margin: 20px;">
                        <div style="width: 121px; height: 135px; border: 1px solid #DDE0E6; border-radius: 8px; display: flex; justify-content: center; align-items: center; flex-direction: column;">
                        <img src=${NeoinQR}alt="qrcode" />
                          <div style="z-index: 1; color: #0044C6; font-size: 12px;">Neoin Card</div>
                        </div>
                      </div>
                    </div>
                    <div style="display: flex;">
                      <div style="padding-left: 10px;">
                        <span style="display: flex;">
                          <span style="margin-right: 10px;"><i class="fas fa-building" style="color: #000;"></i></span>
                          <div>${userDetails.companyname}</div>
                        </span>
                        <span style="display: flex;">
                          <span style="margin-right: 10px;"><i class="fas fa-map-marker-alt" style="color: #000;"></i></span>
                          <div>${userDetails.location}</div>
                        </span>
                        <span style="display: flex;">
                          <span style="margin-right: 10px;"><i class="fas fa-phone" style="color: #000;"></i></span>
                          <div>${userDetails.phone}</div>
                        </span>
                        <span style="display: flex;">
                          <span style="margin-right: 10px;"><i class="fas fa-envelope" style="color: #000;"></i></span>
                          <div>${userDetails.email}</div>
                        </span>
                        <span style="display: flex;">
                          <span style="margin-right: 10px;"><i class="fas fa-globe" style="color: #000;"></i></span>
                          <div>${userDetails.website}</div>
                        </span>
                      </div>
                    </div>
                    <span style="color: #0044C6; font-size: 12px; font-weight: 400; border-bottom: 1px solid #0044C6; width: 67px; height: 14px; position: relative; right: -260px; margin-bottom: 10px; margin-top: -10px;">Add Contact</span>
                  </div>
                </div>
              </div>
              
            `;
    } else if (
      qrChecked &&
      !textChecked &&
      !profileChecked &&
      !logoChecked &&
      !borderlineChecked &&
      !defaultChecked
    ) {
      // Generate the signature for QR only
      signature = `
              <!-- QR signature content here -->

              <span style="color: #000000DE; font-size: 16px; font-weight: 400; display: block; padding: 20px; text-align:center;">Preview Card</span>
              <div style="box-shadow: 0px 0px 2px 0px #919EAB33; width: 210px; min-height: 160px; border-radius: 8px; margin-bottom: 30px; color: ${fontColor}; border: 1px solid ${borderColor}; font-style: ${fontStyle}; font-family: ${fontStyle};">
                <div style="margin: 10px; width: calc(100% - 20px); height: calc(100% - 20px); box-shadow: 0px 12px 24px 0px #919EAB1F; border-radius: 8px;">
                  <div style="display: flex; flex-direction: column;">
              <div style="flex: 2; width: 100%; padding-left: 10px; margin: 20px;">
              <div style="width: 121px; height: 135px; border: 1px solid #DDE0E6; border-radius: 8px; display: flex; justify-content: center; align-items: center; flex-direction: column;">
              <img src=${NeoinQR} alt="qrcode" />
                <div style="z-index: 1; color: #0044C6; font-size: 12px;">Neoin Card</div>
              </div>
            </div>
            </div>
            </div>
            </div>
  
            `;
    } else if (
      !qrChecked &&
      textChecked &&
      !profileChecked &&
      !logoChecked &&
      !borderlineChecked
    ) {
      // Generate the signature for text only
      signature = `
              <!-- Text signature content here -->
              <span style="color: #000000DE; font-size: 16px; font-weight: 400; display: block; padding: 20px; text-align:center;">Preview Card</span>
              <div style="box-shadow: 0px 0px 2px 0px #919EAB33; width: 210px; min-height: 160px; border-radius: 8px; margin-bottom: 30px; color: ${fontColor}; border: 1px solid ${borderColor}; font-style: ${fontStyle}; font-family: ${fontStyle};">
                  <divstyle="margin: 10px; width: calc(100% - 20px); height: calc(100% - 20px); box-shadow: 0px 12px 24px 0px #919EAB1F; border-radius: 8px;">
                      <div style="display: flex; flex-direction: column;">
                          <div style="display: flex;">
                              <div style=" flex: 2;width: 100%; padding-left: 10px;margin: 20px;">
                                  <div>
                                      <p style="font-size: 14px; font-weight: 400; line-height: 16.8px; text-align: left;color: #000000DE;">${userDetails.name}</p>
                                      <p class="helper-text-style">${userDetails.profession}</p>
                                      <span class="digital-card-line">
                                          <BusinessIcon class="card-icon color-grey" />
                                          <div class="text-content">${userDetails.companyname}</div>
                                      </span>
                                      <span class="digital-card-line">
                                          <LocationOnIcon class="card-icon color-grey" />
                                          <div class="text-content">${userDetails.location}</div>
                                      </span>
                                      <span class="digital-card-line">
                                          <PhoneIphoneIcon class="card-icon color-grey" />
                                          <div class="text-content">${userDetails.phone}</div>
                                      </span>
                                      <span class="digital-card-line">
                                          <EmailIcon class="card-icon color-grey" />
                                          <div class="text-content">${userDetails.email}</div>
                                      </span>
                                      <span class="digital-card-line">
                                          <PublicIcon class="card-icon color-grey" />
                                          <div class="text-content">${userDetails.website}</div>
                                      </span>
                                      <span class="neoin-card">Neoin Card</span>
                                      <span class="Add-contact-paid-1">Add Contact</span>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

            `;
    } else if (
      !qrChecked &&
      !textChecked &&
      profileChecked &&
      !logoChecked &&
      !borderlineChecked
    ) {
      // Generate the signature for profile only
      signature = `
              <!-- Profile signature content here -->
              <div class="circle-container">
               <div class="circle-image"> 
              <img src="${userDetails.proFile}" alt="profile" />
               </div>
            </div>

            `;
    } else if (
      !qrChecked &&
      !textChecked &&
      !profileChecked &&
      logoChecked &&
      !borderlineChecked
    ) {
      // Generate the signature for logo only
      signature = `
              <!-- Logo signature content here -->
              <div class="small-circle-container">
              <img class="companylogo2" src="${userDetails.companyLogo}" alt="company-alt" />
            </div>
            `;
    } else if (
      qrChecked &&
      textChecked &&
      !profileChecked &&
      !logoChecked &&
      !borderlineChecked
    ) {
      // Generate the signature for QR and text
      signature = `
              <!-- QR and text signature content here -->
              <span class="card-header-paid">Preview Card</span>
  <div class="default-card-outline" style="color: ${fontColor}; font-style: ${fontStyle}; font-family: ${fontStyle};">
    <div class="digital-card-start">
      <div class="container-paid-card">
        <div class="row-paid-card">
          <div class="col-paid-card">
            <p class="Name-paid-card" style="color: ${fontColor};">${userDetails.name}</p>
            <p class="helper-text-style">${userDetails.profession}</p>
          </div>
          <div class="col-paid-card">
            <div class="Neoin-card-paid-border">
              <div class="Neoin-card-paid">
                <img src="${userDetails.neoinwithqr}" alt="qrcode" />
                <span class="neoin-card">Neoin Card</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row-paid-card">
          <div class="pl-10px">
            <span class="digital-card-line">
              <BusinessIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.companyname}</div>
            </span>
            <span class="digital-card-line">
              <LocationOnIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.location}</div>
            </span>
            <span class="digital-card-line">
              <PhoneIphoneIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.phone}</div>
            </span>
            <span class="digital-card-line">
              <EmailIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.email}</div>
            </span>
            <span class="digital-card-line">
              <PublicIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.website}</div>
            </span>
          </div>
        </div>
        <span class="Add-contact-paid">Add Contact</span>
      </div>
    </div>
  </div>
            `;
    } else if (
      qrChecked &&
      textChecked &&
      profileChecked &&
      !logoChecked &&
      !borderlineChecked
    ) {
      // Generate the signature for QR, text, and profile
      signature = `
              <!-- QR, text, and profile signature content here -->
              <span class="card-header-paid">Preview Card</span>
  <div class="default-card-outline" style="color: ${fontColor}; font-style: ${fontStyle}; font-family: ${fontStyle};">
    <div class="digital-card-start">
      <div class="container-paid-card">
        <div class="row-paid-card">
          <div class="col-paid-card">
            <div>
              <div class="circle-container">
                <!-- <div class="circle-image"> -->
                <img src="${userDetails.proFile}" alt="profile" />
                <!-- </div> -->
              </div>
            </div>
            <p class="Name-paid-card" style="color: ${fontColor};">${userDetails.name}</p>
            <p class="helper-text-style">${userDetails.profession}</p>
          </div>
          <div class="col-paid-card">
            <div class="Neoin-card-paid-border">
              <div class="Neoin-card-paid">
                <img src="${userDetails.neoinwithqr}" alt="qrcode" />
                <span class="neoin-card">Neoin Card</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row-paid-card">
          <div class="pl-10px">
            <span class="digital-card-line">
              <BusinessIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.companyname}</div>
            </span>
            <span class="digital-card-line">
              <LocationOnIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.location}</div>
            </span>
            <span class="digital-card-line">
              <PhoneIphoneIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.phone}</div>
            </span>
            <span class="digital-card-line">
              <EmailIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.email}</div>
            </span>
            <span class="digital-card-line">
              <PublicIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.website}</div>
            </span>
          </div>
        </div>
        <span class="Add-contact-paid">Add Contact</span>
      </div>
    </div>
  </div>

            `;
    } else if (
      qrChecked &&
      textChecked &&
      !profileChecked &&
      logoChecked &&
      !borderlineChecked
    ) {
      // Generate the signature for QR, text, and logo
      signature = `
              <!-- QR, text, and logo signature content here -->
              <!-- Default signature content here -->
              <span class="card-header-paid">Preview Card</span>
  <div class="default-card-outline" style="color: ${fontColor}; border: 1px solid ${borderColor}; font-style: ${fontStyle}; font-family: ${fontStyle};">
    <div class="digital-card-start">
      <div class="container-paid-card">
        <div class="row-paid-card">
          <div class="col-paid-card">
            <div>
              <div class="small-circle-container">
                <img class="companylogo2" src="${userDetails.companyLogo}" alt="company-alt" />
              </div>
            </div>
            <p class="Name-paid-card" style="color: ${fontColor};">${userDetails.name}</p>
            <p class="helper-text-style">${userDetails.profession}</p>
          </div>
          <div class="col-paid-card">
            <div class="Neoin-card-paid-border">
              <div class="Neoin-card-paid">
                <img src="${userDetails.neoinwithqr}" alt="qrcode" />
                <span class="neoin-card">Neoin Card</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row-paid-card">
          <div class="pl-10px">
            <span class="digital-card-line">
              <BusinessIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.companyname}</div>
            </span>
            <span class="digital-card-line">
              <LocationOnIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.location}</div>
            </span>
            <span class="digital-card-line">
              <PhoneIphoneIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.phone}</div>
            </span>
            <span class="digital-card-line">
              <EmailIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.email}</div>
            </span>
            <span class="digital-card-line">
              <PublicIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.website}</div>
            </span>
          </div>
        </div>
        <span class="Add-contact-paid">Add Contact</span>
      </div>
    </div>
  </div>
            `;
    } else if (
      qrChecked &&
      textChecked &&
      profileChecked &&
      logoChecked &&
      !borderlineChecked
    ) {
      // Generate the signature for QR, text, profile, and logo
      signature = `
              <!-- QR, text, profile, and logo signature content here -->
              <!-- Default signature content here -->
              <span class="card-header-paid">Preview Card</span>
  <div class="default-card-outline" style="color: ${fontColor}; border: 1px solid ${borderColor}; font-style: ${fontStyle}; font-family: ${fontStyle};">
    <div class="digital-card-start">
      <div class="container-paid-card">
        <div class="row-paid-card">
          <div class="col-paid-card">
            <div>
              <div class="circle-container">
                <!-- <div class="circle-image"> -->
                <img src="${userDetails.proFile}" alt="profile" />
                <!-- </div> -->
              </div>
              <div class="small-circle-container">
                <img class="companylogo2" src="${userDetails.companyLogo}" alt="company-alt" />
              </div>
            </div>
            <p class="Name-paid-card" style="color: ${fontColor};">${userDetails.name}</p>
            <p class="helper-text-style">${userDetails.profession}</p>
          </div>
          <div class="col-paid-card">
            <div class="Neoin-card-paid-border">
              <div class="Neoin-card-paid">
                <img src="${userDetails.neoinwithqr}" alt="qrcode" />
                <span class="neoin-card">Neoin Card</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row-paid-card">
          <div class="pl-10px">
            <span class="digital-card-line">
              <BusinessIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.companyname}</div>
            </span>
            <span class="digital-card-line">
              <LocationOnIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.location}</div>
            </span>
            <span class="digital-card-line">
              <PhoneIphoneIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.phone}</div>
            </span>
            <span class="digital-card-line">
              <EmailIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.email}</div>
            </span>
            <span class="digital-card-line">
              <PublicIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.website}</div>
            </span>
          </div>
        </div>
        <span class="Add-contact-paid">Add Contact</span>
      </div>
    </div>
  </div>
            `;
    } else if (
      qrChecked &&
      textChecked &&
      profileChecked &&
      !logoChecked &&
      borderlineChecked
    ) {
      // Generate the signature for QR, text, profile, and borderline
      signature = `
              <!-- Default signature content here -->
              <span class="card-header-paid">Preview Card</span>
  <div class="default-card-outline" style="color: ${fontColor}; border: 1px solid ${borderColor}; font-style: ${fontStyle}; font-family: ${fontStyle};">
    <div class="digital-card-start">
      <div class="container-paid-card">
        <div class="row-paid-card">
          <div class="col-paid-card">
            <div>
              <div class="circle-container">
                <!-- <div class="circle-image"> -->
                <img src="${userDetails.proFile}" alt="profile" />
                <!-- </div> -->
              </div>
              <div class="small-circle-container">
                <img class="companylogo2" src="${userDetails.companyLogo}" alt="company-alt" />
              </div>
            </div>
            <p class="Name-paid-card" style="color: ${fontColor};">${userDetails.name}</p>
            <p class="helper-text-style">${userDetails.profession}</p>
          </div>
          <div class="col-paid-card">
            <div class="Neoin-card-paid-border">
              <div class="Neoin-card-paid">
                <img src="${userDetails.neoinwithqr}" alt="qrcode" />
                <span class="neoin-card">Neoin Card</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row-paid-card">
          <div class="pl-10px">
            <span class="digital-card-line">
              <BusinessIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.companyname}</div>
            </span>
            <span class="digital-card-line">
              <LocationOnIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.location}</div>
            </span>
            <span class="digital-card-line">
              <PhoneIphoneIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.phone}</div>
            </span>
            <span class="digital-card-line">
              <EmailIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.email}</div>
            </span>
            <span class="digital-card-line">
              <PublicIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.website}</div>
            </span>
          </div>
        </div>
        <span class="Add-contact-paid">Add Contact</span>
      </div>
    </div>
  </div>
            `;
    } else if (
      qrChecked &&
      textChecked &&
      profileChecked &&
      logoChecked &&
      borderlineChecked
    ) {
      signature = `
            <!-- Default signature content here -->
              <span class="card-header-paid">Preview Card</span>
  <div class="default-card-outline" style="color: ${fontColor}; border: 1px solid ${borderColor}; font-style: ${fontStyle}; font-family: ${fontStyle};">
    <div class="digital-card-start">
      <div class="container-paid-card">
        <div class="row-paid-card">
          <div class="col-paid-card">
            <div>
              <div class="circle-container">
                <!-- <div class="circle-image"> -->
                <img src="${userDetails.proFile}" alt="profile" />
                <!-- </div> -->
              </div>
              <div class="small-circle-container">
                <img class="companylogo2" src="${userDetails.companyLogo}" alt="company-alt" />
              </div>
            </div>
            <p class="Name-paid-card" style="color: ${fontColor};">${userDetails.name}</p>
            <p class="helper-text-style">${userDetails.profession}</p>
          </div>
          <div class="col-paid-card">
            <div class="Neoin-card-paid-border">
              <div class="Neoin-card-paid">
                <img src="${userDetails.neoinwithqr}" alt="qrcode" />
                <span class="neoin-card">Neoin Card</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row-paid-card">
          <div class="pl-10px">
            <span class="digital-card-line">
              <BusinessIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.companyname}</div>
            </span>
            <span class="digital-card-line">
              <LocationOnIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.location}</div>
            </span>
            <span class="digital-card-line">
              <PhoneIphoneIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.phone}</div>
            </span>
            <span class="digital-card-line">
              <EmailIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.email}</div>
            </span>
            <span class="digital-card-line">
              <PublicIcon class="card-icon color-grey" />
              <div class="text-content">${userDetails.website}</div>
            </span>
          </div>
        </div>
        <span class="Add-contact-paid">Add Contact</span>
      </div>
    </div>
  </div>`;
    }
    return signature;
  };

  const handleDefaultChange = () => {
    setDefaultChecked(!defaultChecked);
    setQRChecked(false);
    setTextChecked(false);
    setProfileChecked(false);
    setLogoChecked(false);
    setBorderlineChecked(false);
  };

  const handleQRChange = () => {
    setDefaultChecked(false);
    setQRChecked(!qrChecked);
    // console.log(qrChecked);
  };

  const handleTextChange = () => {
    setDefaultChecked(false);
    setTextChecked(!textChecked);
  };

  const handleProfileChange = () => {
    setDefaultChecked(false);
    setProfileChecked(!profileChecked);
  };

  const handleLogoChange = () => {
    setDefaultChecked(false);
    setLogoChecked(!logoChecked);
  };

  const handleBorderlineChange = () => {
    setDefaultChecked(false);
    setBorderlineChecked(!borderlineChecked);
  };

  const qrCodeOnlyEnabled =
    qrChecked &&
    !textChecked &&
    !profileChecked &&
    !logoChecked &&
    !borderlineChecked;

  // Function to render card content based on active link
  const renderCardContent = () => {
    let userCardName = "";
    if (selectedCard === "Professional") userCardName = "Business Card";
    else if (selectedCard === "Student") userCardName = "Student Card";
    else if (selectedCard === "GenZ") userCardName = "GenZ Card";
    else if (selectedCard === "Personal") userCardName = "Personal Card";
    else userCardName = `${selectedCard} ` + "Card";
    return (
      <>
        {defaultChecked &&
          !textChecked &&
          !qrChecked &&
          !profileChecked &&
          !logoChecked &&
          !borderlineChecked && (
            <>
              <span className="card-header-paid">Preview Card</span>
              <div
                className="default-card-outline"
                style={{
                  color: fontColor,
                  border: `1px solid ${borderColor}`,
                  fontStyle: fontStyle,
                  fontFamily: fontStyle,
                }}
              >
                <div className="digital-card-start">
                  <div className="container-paid-card">
                    <div className="row-paid-card">
                      <div className="col-paid-card">
                        <div className="">
                          <div>
                            <div className="circle-container">
                              {/* <div className="circle-image"> */}
                              <img src={CardProfilePic} alt="profile" />
                              {/* </div> */}
                            </div>
                            <div className="small-circle-container">
                              <img
                                className="companylogo2"
                                src={cardLogo}
                                alt="company-alt"
                              />
                            </div>
                          </div>
                          <p
                            className="Name-paid-card"
                            style={{ color: fontColor }}
                          >
                            {userDetails.name}
                          </p>
                          <p className="helper-text-style">{CardProfession}</p>
                        </div>
                      </div>
                      <div className="col-paid-card">
                        <div className="Neoin-card-paid-border">
                          <div className="Neoin-card-paid">
                            {/* <img src={NeoinQR} alt="qrcode" /> */}
                            <a
                              href={`${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}`}
                              rel="noopener noreferrer"
                            >
                              <QRCode
                                className="container-gift-1"
                                value={`${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}`}
                                style={{ width: 70, height: 70 }}
                              />
                            </a>
                          </div>
                        </div>
                        <span className="text-center">{userCardName}</span>
                      </div>
                    </div>
                    <div className="row-paid-card">
                      <div className="pl-10px">
                        <span className="digital-card-line">
                          <BusinessIcon className="card-icon color-grey" />
                          <div className="text-content">
                            {userDetails.companyname}
                          </div>
                        </span>
                        <span className="digital-card-line">
                          <LocationOnIcon className="card-icon color-grey" />
                          <div className="text-content">
                            {userDetails.location}
                          </div>
                        </span>
                        <span className="digital-card-line">
                          <PhoneIphoneIcon className="card-icon color-grey" />
                          <div className="text-content">
                            {userDetails.phone}
                          </div>
                        </span>
                        <span className="digital-card-line">
                          <EmailIcon className="card-icon color-grey" />
                          <div className="text-content">
                            {userDetails.email}
                          </div>
                        </span>
                        <span className="digital-card-line">
                          <PublicIcon className="card-icon color-grey" />
                          <div className="d-flex flex-row justify-content-between align-items-center">
                            <div className="text-content">
                              {userDetails.website}
                            </div>
                            <span className="Add-contact-txt d-flex justify-content-end p-2">
                              <u> Add Contact</u>
                            </span>
                          </div>
                        </span>
                      </div>
                    </div>
                    {/* <span className="Add-contact-paid">Add Contact</span> */}
                  </div>
                </div>
              </div>
            </>
          )}

        {!defaultChecked && !qrCodeOnlyEnabled && (
          <>
            <span className="card-header-paid">Preview Card</span>
            <div
              className="default-card-outline"
              style={{
                color: fontColor,
                border: `1px solid ${borderColor}`,
                fontStyle: fontStyle,
                fontFamily: fontStyle,
              }}
            >
              <div
                className={`digital-card-start ${borderlineChecked ? "border-blue" : ""
                  }`}
                style={{
                  padding:
                    profileChecked || logoChecked || textChecked
                      ? "20px"
                      : "10px", // Adjust padding when no content
                  minHeight:
                    profileChecked || logoChecked || textChecked
                      ? "300px"
                      : "150px", // Adjust height based on content
                }}
              >
                <div className="container-paid-card">
                  <div className="row-paid-card">
                    <div className="col-paid-card">
                      <div className="">
                        {/* Conditionally Show Profile Picture */}
                        {profileChecked && (
                          <div>
                            <div className="circle-container">
                              <img src={CardProfilePic} alt="profile" />
                            </div>
                            {/* Conditionally Show Company Logo */}
                            {logoChecked && (
                              <div className="small-circle-container">
                                <img
                                  className="companylogo2"
                                  src={cardLogo}
                                  alt="company-alt"
                                />
                              </div>
                            )}
                          </div>
                        )}
                        {!profileChecked && logoChecked && (
                          <div className="circle-container">
                            <img
                              src={CardProfilePic}
                              alt="logocompany"
                              className="image-logo-container"
                            />
                          </div>
                        )}

                        {/* Conditionally Show Text Details */}
                        {textChecked && (
                          <div className="mt-10">
                            <p
                              className="Name-paid-card"
                              style={{ color: fontColor }}
                            >
                              {userDetails.name}
                            </p>
                            <p className="helper-text-style">
                              {CardProfession}
                            </p>
                            <span className="digital-card-line">
                              <BusinessIcon className="card-icon color-grey" />
                              <div className="text-content">
                                {userDetails.companyname}
                              </div>
                            </span>
                            <span className="digital-card-line">
                              <LocationOnIcon className="card-icon color-grey" />
                              <div className="text-content">
                                {userDetails.location}
                              </div>
                            </span>
                            <span className="digital-card-line">
                              <PhoneIphoneIcon className="card-icon color-grey" />
                              <div className="text-content">
                                {userDetails.phone}
                              </div>
                            </span>
                            <span className="digital-card-line">
                              <EmailIcon className="card-icon color-grey" />
                              <div className="text-content">
                                {userDetails.email}
                              </div>
                            </span>
                            <span className="digital-card-line">
                              <PublicIcon className="card-icon color-grey" />
                              <div className="text-content">
                                {userDetails.website}
                              </div>
                            </span>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Conditionally Show QR Code */}
                    {qrChecked && (
                      <div className="d-flex flex-column justify-content-start align-items-center me-4">
                        <div className="Neoin-card-paid-border">
                          <div className="Neoin-card-paid">
                            <a
                              href={`${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}`}
                              rel="noopener noreferrer"
                            >
                              <QRCode
                                className="container-gift-1"
                                value={`${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}`}
                                style={{ width: 70, height: 70 }}
                              />
                            </a>
                          </div>
                        </div>
                        <span className="business-card d-flex align-items-center justify-content-center m-1">
                          {userCardName}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {qrCodeOnlyEnabled && (
          <>
            <span className="card-header-paid">Preview Card</span>
            <div
              className="default-card-outline"
              style={{
                color: fontColor,
                border: `1px solid ${borderColor}`,
                fontStyle: fontStyle,
                fontFamily: fontStyle,
              }}
            >
              <div
                className={`digital-card-start ${borderlineChecked ? "border-blue" : ""
                  }`}
              >
                <div className="container-paid-card">
                  <div className="row-paid-card">
                    {qrChecked && (
                      <div
                        className="d-flex flex-column justify-content-center align-items-center m-5 p-5"
                        style={{ height: "100%", minHeight: "200px" }} // Set minHeight to ensure QR code is centered even if there's no content around
                      >
                        <div className="Neoin-card-paid-border">
                          <div className="Neoin-card-paid">
                            <a
                              href={`${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}`}
                              rel="noopener noreferrer"
                            >
                              <QRCode
                                className="container-gift-1"
                                value={`${process.env.REACT_APP_CARD_URL}/digital-identity/${selectedCard}/${objectId}`}
                                style={{ width: 100, height: 100 }} // Adjusted size for visibility
                              />
                            </a>
                          </div>
                        </div>
                        <span className="business-card d-flex align-items-center justify-content-center m-1">
                          {userCardName}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </>
    );
  };
  const sliderSettings = {
    infinite: cards.length > 1,
    slidesToShow: cards.length >= 4 ? 4 : cards.length,
    slidesToScroll: 1,
    // autoplay: true,
    autoplaySpeed: 4000,
    nextArrow: (
      <ArrowForwardIosRoundedIcon className="icon-clor" color="#0044C6" />
    ),
    prevArrow: <ArrowBackIosRoundedIcon className="icon-color" />,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: cards.length >= 3 ? 3 : cards.length,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: cards.length >= 2 ? 2 : cards.length,
        },
      },
    ],
  };

  return (
    <>
      <div className="digital-identity-container">
        {/* Image */}
        {!lightboxOpen && (
          <>
            <div
              className="top-images d-flex justify-content-end "
              style={{ height: "300px", width: "80%" }}
            >
              <Box className="digital_identity_Carousel profile-offers-box my-2">
                <Slider {...sliderSettings} sx={{ backgroundColor: "#f4f7fe" }}>
                  {cards.map((userCardName) => {
                    const data = cardDetailsAll[userCardName];
                    const styles = cardStylesAll[userCardName];

                    let profilePicture = data?.profile_pic || DefaultProfileBg;
                    let cardLogo = data?.logo || DefaultProfileBg;

                    return data ? (
                      <div
                        key={userCardName}
                        className={`digi-card card-professional ${selectedCard === userCardName ? "selected-card" : ""
                          }`}
                        style={{ backgroundColor: "#ffffff" }}
                        onClick={() => handleCardClick(userCardName)}
                      >
                        <div
                          className="digi-card-upper"
                          style={{ backgroundImage: `url(${profilePicture})` }}
                        >
                          <div
                            className="digi-card-label-container"
                            style={{ background: "#0044c6" }}
                          >
                            <span className="digi-card-label">
                              {userCardName}
                            </span>
                          </div>

                          {userCardName === "Personal" ? (
                            <CardWaveSmile
                              bgColor={"#ffffff"}
                              strokeColor={styles.colorLayout || "#0044c6"}
                            />
                          ) : (
                            <CardWaveStd
                              bgColor={"#ffffff"}
                              strokeColor={styles.colorLayout || "#0044c6"}
                            />
                          )}

                          {userCardName !== "Personal" && (
                            <div className="company-logo-container flex-center">
                              <img
                                src={cardLogo}
                                alt="Company"
                                className="prof-company-logo"
                              />
                            </div>
                          )}
                        </div>
                        <div className="digi-card-lower">
                          <h2 className="digi-card-Name truncate">
                            {userDetails.name}
                          </h2>
                          <span className="Profession">
                            {/* {cardType === "Professional"
                              ? data?.designation
                              : data?.title} */}
                            {CardProfession}
                          </span>
                        </div>
                      </div>
                    ) : null;
                  })}
                </Slider>
              </Box>
            </div>
            {/* <div className="top-images" style={{ display: "flex" }}> */}
            {/* <img src={card1} alt="Image 1" />
            <img src={card2} alt="Image 2" /> */}
            {/* <div className="digi-card card-professional">
                <div
                  className="digi-card-upper"
                  style={{ backgroundImage: `url(${userDetails.proFile})` }}
                >
                  <div className="digi-card-label-container">
                    <span className="digi-card-label"> Professional</span>
                  </div>
                  <svg
                    class="absolute -bottom-1"
                    preserveAspectRatio="xMinYMax meet"
                    viewBox="0 0 246 57"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      position: "relative",
                      top: "52%",
                      left: "0.09px",
                      width: "100.3%",
                    }}
                  >
                    <path
                      d="M 214.7168,6.1113281 C 195.65271,5.9023124 172.37742,11.948182 137.87305,32.529297 110.16613,49.05604 86.980345,56.862784 65.015625,57 H 65 v 1 H 246 V 11.453125 C 236.0775,8.6129313 226.15525,6.2367376 214.7168,6.1113281 Z"
                      fill="#ffffff"
                      clip-rule="evenodd"
                      fill-rule="evenodd"
                    ></path>
                    <path
                      d="M 0,35.773438 V 58 H 65 L 64.97852,57 C 43.192081,57.127508 22.605139,49.707997 0,35.773438 Z "
                      fill="#ffffff"
                      clip-rule="evenodd"
                      fill-rule="evenodd"
                    ></path>
                    <path
                      fill="#0044C6"
                      clip-rule="evenodd"
                      fill-rule="evenodd"
                      d="m 0,16.7221 v 19.052 C 45.4067,63.7643 82.6667,65.4583 137.873,32.5286 193.08,-0.401184 219.54,3.87965 246,11.4535 V 6.51403 C 185.24,-16.8661 135.913,29.331 97.6933,40.8564 59.4733,52.3818 33.6467,44.1494 0,16.7221 Z "
                    ></path>
                  </svg>
                  <div className="company-logo-container">
                    <img
                      src={companylogo}
                      alt="Company"
                      className="prof-company-logo"
                    />
                  </div>
                </div>
                <div className="digi-card-lower">
                  <h2 className="Name" style={{ fontSize: "18px" }}>
                    {userDetails.name}
                  </h2>
                  <span className="Profession">{userDetails.profession}</span>
                </div>
              </div>
              <div className="digi-card card-personal">
                <div
                  className="digi-card-upper"
                  style={{ backgroundImage: `url(${userDetails.proFile})` }}
                >
                  <div
                    className="digi-card-label-container"
                    style={{ width: "75px" }}
                  >
                    <span className="digi-card-label"> Personal</span>
                  </div>
                  <CardWaveWithoutShadow
                    style={{ position: "relative", top: "63%", width: "100%" }}
                  />
                </div>
                <div className="digi-card-lower">
                  <h2 className="Name" style={{ fontSize: "18px" }}>
                    {userDetails.name}
                  </h2>
                  <span className="Profession">{userDetails.profession}</span>
                </div>
              </div>
            </div> */}
            {/* Links */}
            <div className="rectangle d-flex flex-column">
              <div className="container-digital-card">
                <div className="column1-digital-paid">
                  <div className="right-div-paid">
                    {renderCardContent({ userDetails })}
                  </div>
                </div>

                <div className="column2-digital-paid">
                  <div>
                    <div className="heading-digital-design">
                      <span className="heading-one">Styling</span>
                      <span className="heading-two">Configuration</span>
                    </div>

                    <div className="Container-new-paid">
                      <div className="column1-small-digital-paid">
                        <div className="content-and-options">
                          <div className="customization-options">
                            {/* <p className="description-content">Customise</p> */}
                            <div className="color-options">
                              <p className="mt-10 description-content">
                                Font Color
                              </p>
                              {predefinedFontColors.map((color, index) => (
                                <div
                                  key={index}
                                  className="color-option"
                                  style={{ backgroundColor: color }}
                                  onClick={() => handleFontColorChange(color)}
                                ></div>
                              ))}
                            </div>
                            <div className="mt-10 color-options">
                              <p className="description-content">
                                Card Border Color
                              </p>
                              {predefinedBorderColors.map((color, index) => (
                                <div
                                  key={index}
                                  className="color-option"
                                  style={{ backgroundColor: color }}
                                  onClick={() => handleBorderColorChange(color)}
                                ></div>
                              ))}
                            </div>

                            <div className="mt-10 dropdown-container">
                              <p className="description-content">TypeFace</p>
                              <FormControl>
                                {/* <div className="color-option"></div> */}
                                <Select
                                  value={fontStyle}
                                  onChange={(e) => setFontStyle(e.target.value)}
                                >
                                  {fontStyleOptions.map((option) => (
                                    <MenuItem
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* <div className='column2-small-digital-paid'>
                                                <div className='container-config'>
                                                    <div className="container">
                                                        <div className="row">
                                                            <div className="col-md-6 switch-container">
                                                                <span>Default</span>
                                                                <Switch checked={defaultChecked} onChange={handleDefaultChange} size="small" />
                                                            </div>
                                                            <div className="col-md-6 switch-container">
                                                                <span>QR Based</span>
                                                                <Switch checked={qrChecked} onChange={handleQRChange} size="small" />
                                                            </div>
                                                            <div className="col-md-6 switch-container">
                                                                <span>Text</span>
                                                                <Switch name="text" checked={!defaultChecked && showContent} disabled={defaultChecked} size="small" />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-6 switch-container">
                                                                <span>Profile</span>
                                                                <Switch {...label} defaultChecked size="small" />
                                                            </div>
                                                            <div className="col-md-6 switch-container">
                                                                <span>Logo</span>
                                                                <Switch {...label} defaultChecked size="small" />
                                                            </div>
                                                            <div className="col-md-6 switch-container">
                                                                <span>Borderline</span>
                                                                <Switch {...label} defaultChecked size="small" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> */}
                      <div className="column2-small-digital-paid">
                        <div className="container-config">
                          <div className="container-paid">
                            <div className="row-paid">
                              <div className="col-md-6 switch-container">
                                <span>Default</span>
                                <Switch
                                  checked={defaultChecked}
                                  onChange={handleDefaultChange}
                                  size="small"
                                />
                              </div>
                              <div className="col-md-6 switch-container">
                                <span>QR Based</span>
                                <Switch
                                  checked={qrChecked}
                                  onChange={handleQRChange}
                                  size="small"
                                />
                              </div>
                              <div className="col-md-6 switch-container">
                                <span>Text</span>
                                <Switch
                                  checked={textChecked}
                                  onChange={handleTextChange}
                                  size="small"
                                />
                              </div>
                            </div>
                            <div className="row-paid">
                              <div className="col-md-6 switch-container ">
                                <span>Profile</span>
                                <Switch
                                  checked={profileChecked}
                                  onChange={handleProfileChange}
                                  size="small"
                                />
                              </div>
                              <div className="col-md-6 switch-container">
                                <span>Logo</span>
                                <Switch
                                  checked={logoChecked}
                                  onChange={handleLogoChange}
                                  size="small"
                                />
                              </div>
                              <div className="col-md-6 switch-container">
                                <span>Borderline</span>
                                <Switch
                                  checked={borderlineChecked}
                                  onChange={handleBorderlineChange}
                                  size="small"
                                />
                              </div>
                            </div>
                          </div>
                          <button
                            className="button-align Add-to-Email me-8"
                            onClick={handleClick}
                          >
                            Add to Email
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>{" "}
          </>
        )}
        <Lightbox
          isOpen={lightboxOpen}
          handleClose={handleCloseLightbox}
          emailSignature={generateEmailSignature()}
        />
      </div>
    </>
  );
};

export default DigitalIdentityPaid;
